/* Added for official site: 「各分店介紹」頁面 (by Tanya) - Optimized */
// 原檔名：slider-store.js

// 1. 选定要观察的目标元素
const storeSliderContainer = document.querySelector('.mobile-only .swiper');

// 2. 检查目标是否存在于当前页面
if (storeSliderContainer) {
    let mobileSwiper = null;
    const mobileBreakpoint = 992;

    // Debounce 函数，用于优化 resize 事件
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    
    // 原始的响应式处理逻辑
    function handleResponsiveLayout() {
        const isMobile = window.innerWidth < mobileBreakpoint;
        if (isMobile) {
            if (!mobileSwiper) {
                mobileSwiper = new Swiper('.mobile-only .swiper', {
                    slidesPerView: 1.2,
                    centeredSlides: true,
                    spaceBetween: 20,
                    loop: false,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
            }
        } else {
            if (mobileSwiper) {
                mobileSwiper.destroy(true, true);
                mobileSwiper = null;
            }
        }
    }
    
    // 使用 Debounce 包装我们的函数
    const debouncedHandleLayout = debounce(handleResponsiveLayout, 250);

    // 3. 建立一个观察者
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            // 4. 当目标进入视窗时
            if (entry.isIntersecting) {
                console.log('Store slider is now visible, initializing...'); // (可选) 除错讯息

                // 5. 在这里才执行首次判断和开始监听
                handleResponsiveLayout();
                window.addEventListener('resize', debouncedHandleLayout);

                // 6. 停止观察，这个启动任务只需要做一次
                observer.unobserve(storeSliderContainer);
            }
        });
    });

    // 7. 命令观察者开始观察
    observer.observe(storeSliderContainer);
}